import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { resolveEventFormOrganizationId } from './event-form-org.util';

function hasConfiguredCategories(colors: Record<string, unknown> | undefined): boolean {
  if (!colors || typeof colors !== 'object') {
    return false;
  }
  return Object.keys(colors).some((key) => (key || '').trim() !== '');
}

/**
 * Visibility for event category dropdown on add/edit event forms.
 * Requires at least one category in org setting event_category_colors.
 */
export function event_category_field_visible(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_category_field_visible',
    description:
      'Whether event category field is shown (org has event_category_colors configured).',
    execute: (params?: LoadDataParams): Observable<{ visible: boolean }> => {
      const auth = service.injector.get(AuthService);
      const orgId = resolveEventFormOrganizationId(params, auth);
      if (orgId == null) {
        return of({ visible: false });
      }
      const obs = service.executeDataSource('org_settings', { organizationId: orgId });
      if (!obs) {
        return of({ visible: false });
      }
      return obs.pipe(
        map((res: { data?: Record<string, unknown> }) => {
          const colors = res?.data?.['event_category_colors'] as
            | Record<string, unknown>
            | undefined;
          return { visible: hasConfiguredCategories(colors) };
        }),
        catchError(() => of({ visible: false }))
      );
    },
  };
}
